import { render, staticRenderFns } from "./DialogAddMedios.vue?vue&type=template&id=525d05c7&scoped=true"
import script from "./DialogAddMedios.vue?vue&type=script&lang=js"
export * from "./DialogAddMedios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525d05c7",
  null
  
)

export default component.exports